import { v4 as uuidv4 } from 'uuid';
import { env } from '../../config/env';
import { apiClient, buildHeaders } from './client';
import type { ParametroOtorgante } from '../types';

const SERVICE = env.apiService;

/** Obtiene los parámetros de personalización del otorgante por apikey. */
export async function fetchOtorganteParams(apikey: string): Promise<ParametroOtorgante[]> {
  const headers = buildHeaders(apikey, uuidv4(), uuidv4(), 'form-data');
  const { data } = await apiClient.get<{ payload: ParametroOtorgante[] }>(
    `/v1/sec_${SERVICE}params`,
    { headers, params: { idOtorgante: apikey } },
  );
  return data.payload;
}
